import {createAnchor} from "./create/create-ahchor";
import {createImage} from "./create/create-image";
import {createListItem} from "./create/create-list-item";
import {createParagraph} from "./create/create-paragraph";

export const renderGroupPage = (catalogList) => {
  const groupPageElement = document.querySelector(`.group-page`);

  if (!groupPageElement) {
    return;
  }

  const currentIndex = (document.location.hostname === `localhost`) ? `1` : catalogList.current;

  const groupData = catalogList[currentIndex];

  const titlePage = groupPageElement.querySelector(`.title`);
  const navListElement = groupPageElement.querySelector(`.group-page__navList`);
  const groupListElement = groupPageElement.querySelector(`.group-page__groupList`);

  titlePage.innerHTML = groupData.name;

  const subCatalogList = groupData.subgroup;

  Object.keys(subCatalogList)
    .forEach((subItemId) => {
      const liItemElement = createListItem(`group-page__navItem`);

      const anchorElement = createAnchor(`group-page__navLink`, subCatalogList[subItemId].name, subCatalogList[subItemId].link);
      liItemElement.append(anchorElement);

      navListElement.append(liItemElement);
    });

  Object.keys(subCatalogList)
    .forEach((subItemId) => {
      const liItemElement = createListItem(`group-page__groupItem`);

      const anchorElement = createAnchor(`group-page__groupLink`, ``, subCatalogList[subItemId].link);
      liItemElement.append(anchorElement);

      const imgElement = createImage(`group-page__groupImg`, subCatalogList[subItemId].image, subCatalogList[subItemId].name);
      anchorElement.append(imgElement);

      const paragraphElement = createParagraph(`group-page__groupTitle`, subCatalogList[subItemId].name);
      anchorElement.append(paragraphElement);

      groupListElement.append(liItemElement);
    });
};
